const NOLI_START_DAY_UTC = Date.UTC(2026, 0, 12);
const DAY_MS = 24 * 60 * 60 * 1000;

export const getNoLiDays = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 0;
  const localDayUtc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.max(0, Math.floor((localDayUtc - NOLI_START_DAY_UTC) / DAY_MS) + 1);
};
